const MinimizeIcon = ({ viewBox = "0 0 16 16", className = "hayley-h-4 hayley-w-4 hayley-text-custom-10" }) => {
  return (
    <svg data-testid="minimize-icon" viewBox={viewBox} fill="none" className={className}>
      <path d="M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z" fill="currentColor" />
    </svg>
  );
};

export default MinimizeIcon;
